/**
 * CR-8191: the "Committed by" date — SAL commitments dated on or before it
 * count as committed. Set on Stock Planning (SAL Committed End Date) and in the
 * call-off wizard's warehouse step, and never left blank in either.
 */
import { formatLocalDate } from '../../filters/dateRangePresets';

/** Latest date the inputs accept: the API refuses a year past 9999. */
export const COMMITTED_BY_MAX_DATE = '9999-12-31';

/**
 * Today in the viewer's own time zone, the default whenever no date is set.
 *
 * @returns the local calendar date as `YYYY-MM-DD`
 */
export function todayCommittedBy(): string {
  return formatLocalDate(new Date());
}
